window.addEventListener('DOMContentLoaded', () => {
  'use strict';


  /**
   * Link to open accordion from another page.
   * Check is made by url parameter.
   */
  const externalAccordionLinks = () => {

    // Return if Bootstrap collapse is not present
    if (typeof bootstrap.Collapse !== 'function') {
      return;
    }

    const hash = window.location.hash;
    if (hash) {

      // Check if there are accordions starting with this id
      const accordionExists = document.querySelector('[class*="ucphcontentaccordion"]' + ' ' + hash);

      if (accordionExists) {
        const el = accordionExists.querySelector('.collapse');
        if (el) {
          // Scroll to accordion parent element
          el.closest('[class^="ucphcontentaccordion"]').scrollIntoView();
          // Open accordion if it exists
          new bootstrap.Collapse(el).show();
        }
      }
    }
  }

  externalAccordionLinks();

  /**
   * Handle collapsible items when opening/closing to prevent them from scrolling out of view.
   */
  const maintainScrollPosition = () => {

    // Check if supporting functions exist.
    if (typeof bootstrap.Collapse !== 'function' && typeof reduceMotion !== 'function') {
      return;
    }


    // Semi collapsible accordion: When closed, scroll the top into view.
    const semiItems = document.querySelectorAll('.semi-collapse-item');
    if (semiItems) {
      semiItems.forEach(function (item) {
        item.addEventListener('hide.bs.collapse', function () {
          this.scrollIntoView();
        });
      });
    }

    // Normal accordions: When single view is selected, scroll the top of opened accordion into view.
    const singleItems = document.querySelectorAll('.single-open .accordion-item');
    if (singleItems) {
      singleItems.forEach(function (item) {
        item.addEventListener('show.bs.collapse', function () {
          let scrollOffset = item.offsetTop;

          if (scrollOffset) {
            window.scroll({
              top: scrollOffset,
              left: 0,
              behavior: reduceMotion() === true ? 'auto' : 'smooth'
            })
          }
        });
      });
    }
  }

  maintainScrollPosition();

  /**
  * Link to open accordion from same page.
  * Check for accordion id in links on current page.
  */
  const inPageAccordionLinks = () => {

    // Return if Bootstrap collapse is not present
    if (typeof bootstrap.Collapse !== 'function') {
      return;
    }

    // Look for links that start with hash
    const links = document.querySelectorAll('.main-content a[href^="#"]');
    if (links) {
      links.forEach((item) => {
        if (item) {
          // Get hash value
          let val = item.href.split('#')[1];
          // Remove 'c' from id
          const unwantedCharacter = 'c';
          while (val.charAt(0) == unwantedCharacter) {
            val = val.substring(1);
          }
          // Target accordion link
          const el = document.getElementById('accordion-' + val);
          if (el) {
            item.addEventListener('click', () => {
              el.scrollIntoView();
              // Open accordion if it exists
              new bootstrap.Collapse(el).show();
            });
          }
        }
      });
    }
  }

  inPageAccordionLinks();
});